import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'

import { LowerRegions } from '@/modules/configs/region'

//NOTE acc. WR-665, on EEA site, only English is preserved
export const usePreserveEnglish = (region: LowerRegions) => {
  const [cookies] = useCookies(['locale'])
  const { i18n } = useTranslation()
  const { language: currentLanguage } = i18n

  useEffect(() => {
    if (region === 'eea') {
      if (currentLanguage !== 'en' || cookies['locale'] !== 'en') {
        setTimeout(() => {
          i18n.changeLanguage('en')
        })
      }
    }
  }, [])
}
